import { Injectable } from '@angular/core';
import { Authentication } from '../models/Authentication';
import { environment } from '../../environments/environment';
import { throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SigninService {

  headers = new HttpHeaders();

  constructor(private readonly http: HttpClient) { }

  /**
   *  devuelve la informacion del resumen
   * @param token: string
   */
  globalPosition(token) {
    return this.http.get<any>(environment.url + '/Account/User', { headers: this.headers.set('Authorization', token) })
      .pipe(retry(0), catchError(this.errorHandl));
  }

  /**
   * @param data datos recibidos del formulario
   * @param captcha token recibido por servicio de captcha
   */
  signUp(body, captcha) {
    return this.http.post(environment.url + '/Login/Register', body, { headers: this.headers.set('recaptchaR', captcha) })
      .pipe(retry(0), catchError(this.errorHandl));
  }

  /**
   * @param data datos recibidos del formulario de Santander Consumer (web privada)
   * @param captcha token recibido por servicio de captcha
   */
  signInSCF(body, captcha) {
    return this.http.post(environment.url + '/Login/SCF', body, { headers: this.headers.set('recaptchaR', captcha) })
      .pipe(retry(0), catchError(this.errorHandl));
  }

  /**
   * 
   * @param c codigo de activacion
   */
  userActivate(c) {
    return this.http.post(environment.url + '/Login/Activate', c).pipe(retry(0), catchError(this.errorHandl));
  }

  /**
   * Desbloquear el usuario bloqueado 
   * @param code es el email de recuperación de password
   * @param captcha token recibido
   */
  unLockUser(c, captcha) {
    return this.http.post(environment.url + '/Login/Unlock', c, {
      headers: this.headers.set('recaptchaR', captcha)
    })
      .pipe(retry(0), catchError(this.errorHandl));
  }

  /**
   * Envia el codigo de nueva contraseña
   * @param code es el email de recuperación de password
   * @param captcha token recibido
   */
  recoverPass(c, captcha) {
    return this.http.post(environment.url + '/Login/ChangeA', c, {
      headers: this.headers.set('recaptchaR', captcha)
    })
      .pipe(retry(0), catchError(this.errorHandl));
  }

  /**
   * Envia el email para que sea cambiado
   * @param code es el email de recuperación de password
   * @param captcha token recibido
   */
  sendMail(c, captcha) {
    return this.http.post(environment.url + '/Login/Change', { Email: c }, {
      headers: this.headers.set('recaptchaR', captcha)
    })
      .pipe(retry(0), catchError(this.errorHandl));
  }

  /**
   * devuelde la key del captcha
   */
  getCaptchaKey(codePetition ?: string) {
    const code = codePetition ? '?codepetition=' + codePetition : '';
    return this.http.get(environment.url + '/OnInit' + code).pipe(retry(0), catchError(this.errorHandl));
  }

  /**
   * aceptar terminos y condiciones
   * @param body: any
   * @param captcha: string
   */
  termsAndConditions(body, captcha) {
    return this.http.post<Authentication>(environment.url + '/Account/TermsConditions',
      body, { headers: this.headers.set('recaptchaR', captcha) })
      .pipe(retry(1), catchError(this.errorHandl));
  }

  /**
   * 
   * @param c body del formulario de inicio de session
   * @param captcha token de recaptcha
   */
  loginAkana(c, captcha) {
    return this.http.post(environment.url + '/Login/Akana', c, {
      headers: this.headers.set('recaptchaR', captcha)
    })
      .pipe(retry(0), catchError(this.errorHandl));
  }

  errorHandl(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
